import theme from "@/theme";
import { Tab, Tabs } from "@mui/material";
import { SyntheticEvent, useState } from "react";
import { useTranslation } from "react-i18next";

interface TightTabsProps {
  selectedTab: string;
  baseRoute: string;
  matchedLocations?: string[];
  onTabOneClicked?: () => void;
  onTabTwoClicked?: () => void;
  routes?: string[];
  labels: string[];
  setSelectedTab: (newTab: string) => void;
  getMatchedLocation?: () => string;
  isMatchedLocationPartOfRoute?: () => boolean;
}

export default function TightTabs({
  selectedTab,
  setSelectedTab,
  labels,
  onTabOneClicked,
  onTabTwoClicked,
}: TightTabsProps) {
  const { t } = useTranslation();

  const [textColour] = useState<
    "primary" | "secondary" | "inherit" | undefined
  >("primary");

  function onTabChange(_event: SyntheticEvent, newTab: string) {
    setSelectedTab(newTab);
  }

  return (
    <Tabs
      textColor={textColour}
      value={selectedTab}
      onChange={onTabChange}
      variant="fullWidth"
      sx={{
        ".MuiButtonBase-root": {
          width: "100%",
          marginRight: "0px",
          marginLeft: "0px",
          borderBottomRightRadius: 0,
          borderTopRightRadius: 0,
          borderTopLeftRadius: theme.shape.borderRadius,
          borderBottomLeftRadius: theme.shape.borderRadius,

          "&:last-child": {
            marginRight: 0,
            borderBottomRightRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
        },
        gap: 0,
        display: "flex",
      }}
    >
      <Tab
        sx={{
          textAlign: "center",
          display: "flex",
          ".MuiTabs-root": {
            borderBottomRightRadius: "8px",
            borderTopRightRadius: "8px",
          },
        }}
        value="buy-voucher"
        component="button"
        label={t(labels[0] as any)}
        aria-label={t(labels[0] as any)}
        onClick={onTabOneClicked}
      />
      <Tab
        sx={{ textAlign: "center" }}
        value="use-voucher"
        label={t(labels[1] as any)}
        component="button"
        aria-label={t(labels[1] as any)}
        onClick={onTabTwoClicked}
      />
    </Tabs>
  );
}
